import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppliancesOven = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "appliances-oven" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 2.25,
			y: 1.5,
			width: 19.5,
			height: 21
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: .75,
			y1: 1.5,
			x2: 23.25,
			y2: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: .75,
			y1: 22.5,
			x2: 23.25,
			y2: 22.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 5.25,
			y: 10.5,
			width: 13.5,
			height: 9,
			rx: .961,
			ry: .961
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 9,
			y1: 13.5,
			x2: 15,
			y2: 13.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M5.25,4.125a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M8.25,4.125a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 2.25,
			y1: 7.5,
			x2: 21.75,
			y2: 7.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 13.5,
			y1: 4.5,
			x2: 18.75,
			y2: 4.5
		})
	]
});
export default SvgAppliancesOven;
